"use strict";
import('./Bootstrap');
